import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import mixin from '@/mixin/index.js';
import SectionTitle from '@/components/SectionTitle.vue';
import SectionItemTitle from '@/components/SectionItemTitle.vue';
import SectionItem from '@/components/SectionItem.vue';
import SectionSubItem from '@/components/SectionSubItem.vue';
import SectionParagraph from '@/components/SectionParagraph.vue';
import Sections from '@/components/Sections.vue';
import GeneralTab from '@/components/GeneralTab.vue';
import SectionLink from '@/components/SectionLink.vue';
import DoseCard from '@/components/DoseCard.vue';
import SmallHeader from '@/components/SmallHeader.vue';
import ProductCard from '@/components/ProductCard.vue';
import ProductsTab from '@/components/ProductsTab.vue';
import DosesTab from '@/components/DosesTab.vue';
import CalculatorButton from '@/components/CalculatorButton.vue';
import ReferenceCard from '@/components/ReferenceCard.vue';
import DrugsHeader from '@/components/DrugsHeader.vue';
import Carousel from '@/components/Carousel.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import CardTitle from '@/components/CardTitle.vue';
import Dialog from '@/components/Dialog.vue';

Vue.config.productionTip = false;
Vue.mixin(mixin);
Vue.component('vetalfa-sections', Sections);
Vue.component('vetalfa-section-title', SectionTitle);
Vue.component('vetalfa-section-item-title', SectionItemTitle);
Vue.component('vetalfa-section-item', SectionItem);
Vue.component('vetalfa-section-sub-item', SectionSubItem);
Vue.component('vetalfa-section-paragraph', SectionParagraph);
Vue.component('vetalfa-general-tab', GeneralTab);
Vue.component('vetalfa-dose-card', DoseCard);
Vue.component('vetalfa-small-header', SmallHeader);
Vue.component('vetalfa-product-card', ProductCard);
Vue.component('vetalfa-products-tab', ProductsTab);
Vue.component('vetalfa-section-link', SectionLink);
Vue.component('vetalfa-doses-tab', DosesTab);
Vue.component('vetalfa-calculator-button', CalculatorButton);
Vue.component('vetalfa-reference-card', ReferenceCard);
Vue.component('vetalfa-drugs-header', DrugsHeader);
Vue.component('vetalfa-carousel', Carousel);
Vue.component('vetalfa-simple-table', SimpleTable);
Vue.component('vetalfa-card-title', CardTitle);
Vue.component('vetalfa-dialog', Dialog);

if (process.env.VUE_APP_ENV != 'hml'
  || window.localStorage.getItem(process.env.VUE_APP_VETALFA_HML_KEY) == process.env.VUE_APP_VETALFA_HML_PASS
  || prompt() == process.env.VUE_APP_VETALFA_HML_PASS) {
  window.localStorage.setItem(process.env.VUE_APP_VETALFA_HML_KEY, process.env.VUE_APP_VETALFA_HML_PASS);
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
}